import React, { useContext, useState, useEffect } from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import SessionContext from '@providers/Session/SessionContext';
import useSwr from '@hooks/useSwr';
import { AlarmGraphAppNameOptions } from '@utils/alarmsConstants';

interface TransactionStatusFieldProps {
  options: Array<{ label: string; value: string }>;
  loading: boolean;
  disabled?: boolean;
}

export function TransactionStatusField({
  options,
  loading,
  disabled = false,
}: TransactionStatusFieldProps) {
  const { t } = useTranslation('create-alarm-step');
  const { customer } = useContext(SessionContext);
  const customerId = customer?.customerLogged?.id;
  const [selectedSite, setSelectedSite] = useState<string | undefined>();
  const form = Form.useFormInstance();

  const { data: statusData } = useSwr<{
    data?: string[];
  }>(
    customerId && selectedSite
      ? `/service-proxy/dashboard/transacao/alarme/kapacitor/alerta_task/listar_transacao_site?site=${selectedSite}&customerId=${customerId}&tipoGrafico=${AlarmGraphAppNameOptions.APPNAME_TRANSACTION_STATUS}`
      : null,
    {
      headers: {
        customerId,
        site: selectedSite,
        tipoGrafico: AlarmGraphAppNameOptions.APPNAME_TRANSACTION_STATUS,
      },
    },
  );

  useEffect(() => {
    if (selectedSite) {
      form.setFieldValue('transactionStatusStatus', undefined);
    }
  }, [selectedSite, form]);

  useEffect(() => {
    const formValue = form.getFieldValue('transactionStatus');
    if (formValue && !selectedSite) {
      setSelectedSite(formValue);
    }
  }, [form, selectedSite]);

  const statusOptions = Array.isArray(statusData)
    ? statusData.map(item => ({ label: item, value: item }))
    : (statusData?.data || []).map(item => ({ label: item, value: item }));

  return (
    <>
      <Form.Item
        name="transactionStatus"
        label={t(
          'create-alarm-step:stepOne.createAlarmTransactionsStatusField',
        )}
        rules={[
          {
            required: true,
            message: t(
              'create-alarm-step:stepOne.createAlarmTransactionsStatusRequired',
            ),
          },
        ]}
      >
        <Select
          allowClear
          options={options}
          loading={loading}
          disabled={loading || disabled}
          style={{ textAlign: 'left' }}
          onChange={value => {
            setSelectedSite(value);
            form.setFieldValue('transactionStatusStatus', undefined);
          }}
        />
      </Form.Item>

      {selectedSite && (
        <Form.Item
          name="transactionStatusStatus"
          label={t('create-alarm-step:stepOne.createAlarmStatusField')}
          rules={[
            {
              required: true,
              message: t(
                'create-alarm-step:stepOne.createAlarmStatusFieldRequired',
              ),
            },
          ]}
        >
          <Select
            allowClear
            options={statusOptions}
            loading={!statusData}
            disabled={!statusData}
            style={{ textAlign: 'left' }}
          />
        </Form.Item>
      )}
    </>
  );
}
